//대시보드
import React, { useState, useEffect, useCallback } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { palette } from "../../../assets/styles/Palette";
import {
  Body2,
  Sub2,
  Body1,
  H4,
  H3,
  Body3,
} from "../../../assets/styles/Typography";
import { Button } from "../../../assets/styles/ButtonStyle";
import MoleculeHeader from "../../Global/components/molecules/MoleculeHeader";
import { useAtom } from "jotai";
import {
  IS_LOGGED_IN,
  AUTODISPLAY_SELECTED_DEVICE,
  AUTODISPLAY_DISPLAY_LIST,
  AUTODISPLAY_CONTENT_LIST,
  CUSTOMER_ID,
  CUSTOMER_NAME,
  CUSTOMER_DETAIL,
} from "../../AtomStates";
import OrganismDashboardDisplayList from "../components/organisms/OrganismDashboardDisplayList";
import OrganismEduDashboardContentList from "../components/organisms/OrganismEduDashboardContentList";

import TemplateEducationContentsList from "../components/templates/TemplateEducationContentsList";
import MoleculeContentTimeline from "../../CreateEducationContentPage/components/molecules/MoleculeContentTimeline";
import MoleculeContentTimeMonth from "../../CreateEducationContentPage/components/molecules/MoleculeContentTimeMonth";
import OrganismContentList from "../components/organisms/OrganismContentList";

import {
  createDisplayOnServer,
  updateDisplayOnServer,
  getDisplayListOnServer,
  getDisplayListCustomerOnServer,
  getEduViewListOnServer,
  getEduViewListCustomerOnServer,
  getUserMemberType,
  getUserInfo,
  getCustomerDetailOnServer,
  getEduBoardListOnServer,
  getEduBoardDetailOnServer,
  getEduBoardDeleteListOnServer,
  createEduBoardOnServer,
  updateEduBoardOnServer,
  createEduTimetableOnServer,
  getEduTimetableListOnServer,
  getEduTimetableDetailOnServer,
  getEduTimetableDeleteListOnServer,
  updateEduTimetableOnServer,
  getEduBoardLotationListOnServer,
  getEduTimetableLotationDetailOnServer,
  viewDetailActivateLinkEduLotationRequest,
} from "../../../utils/indexedDB";
import AutodisplaySelectedPopup from "../components/molecules/AutodisplaySelectedPopup";
import {
  TabWrapType3,
  TabButtonType3,
} from "../../../assets/styles/BusinessAnalysisStyle";

const PageEducationDashBoard = () => {
  const navigate = useNavigate();

  // 대시보드 상태 데이터
  const [stats] = useState({
    displayList: 5,
    totalContent: 20,
    activeContent: 10,
    credits: 21250,
  });
  const [activeTab, setActiveTab] = useState("content");
  // 뷰 전환 상태 추가
  const [currentView, setCurrentView] = useState("dashboard"); // 'dashboard' | 'contentsList'
  // 팝업 관련 상태
  const [isLoggedIn, setIsLoggedIn] = useAtom(IS_LOGGED_IN);
  const [selectedDevice, setSelectedDevice] = useAtom(
    AUTODISPLAY_SELECTED_DEVICE
  );
  const [customerId, setCustomerId] = useAtom(CUSTOMER_ID);
  const [customerName, setCustomerName] = useAtom(CUSTOMER_NAME);
  const [customerDetail, setCustomerDetail] = useAtom(CUSTOMER_DETAIL);
  const [isCustomizePopupOpen, setIsCustomizePopupOpen] = useState(false);
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [addDisplayForm, setAddDisplayForm] = useState({
    deviceTitle: "",
    deviceLocation: "",
    deviceTarget: "",
    deviceSpec: {
      deviceWidth: "",
      deviceHeight: "",
      deviceWidthMM: "",
      deviceHeightMM: "",
      deviceCm: "",
      deviceResolution: "",
      deviceDPI: "",
      deviceInch: "",
    },
  });
  const [activateCount, setActivateCount] = useState(0);
  const [selectBoxStates, setSelectBoxStates] = useState({
    deviceDPI: false,
    deviceInch: false,
  });
  const [showDeviceSelectPopup, setShowDeviceSelectPopup] = useState(false);
  const [isTypingDPI, setIsTypingDPI] = useState(false);
  const [isTypingInch, setIsTypingInch] = useState(false);
  const [displayList, setDisplayList] = useAtom(AUTODISPLAY_DISPLAY_LIST);
  const [contentList, setContentList] = useAtom(AUTODISPLAY_CONTENT_LIST);
  const [newDisplayId, setNewDisplayId] = useState(null);
  const [selectedEditDisplayId, setSelectedEditDisplayId] = useState(null);
  const [companyName, setCompanyName] = useState("");
  const [monthOffset, setMonthOffset] = useState(0);
  const [timelineViewType, setTimelineViewType] = useState("weekly"); // 'weekly' | 'monthly'
  const [currentWeekOffset, setCurrentWeekOffset] = useState(0); // 현재 주로부터의 오프셋
  const [currentUserName, setCurrentUserName] = useState("");
  const [eduTimetableDetail, setEduTimetableDetail] = useState(null);
  const [isTimetableLoading, setIsTimetableLoading] = useState(true);
  const [lotationDetail, setLotationDetail] = useState(null);
  const [contentListAllCount, setContentListAllCount] = useState(0);
  const [contentListGrade1Count, setContentListGrade1Count] = useState(0);
  const [contentListGrade2Count, setContentListGrade2Count] = useState(0);
  const [contentListGrade3Count, setContentListGrade3Count] = useState(0);

  // 고객사 정보를 불러오는 함수
  // const fetchCustomerAndTimetableDetails = async (monthOffsetValue) => {
  //   setIsTimetableLoading(true);
  //   const customerIdFromStorage = sessionStorage.getItem("customerId") || "";
  //   const userName = sessionStorage.getItem("userName") || "";
  //   setCustomerId(customerIdFromStorage);
  //   setCurrentUserName(userName);

  //   const targetDate = new Date();
  //   targetDate.setMonth(targetDate.getMonth() + monthOffsetValue);
  //   const currentYear = targetDate.getFullYear();
  //   const currentMonth = String(targetDate.getMonth() + 1).padStart(2, '0');
  //   const tableId = customerIdFromStorage + `-${currentYear}-${currentMonth}`;

  //   try {
  //       const eduTimetableDetailData = await getEduTimetableDetailOnServer(tableId);
  //       setEduTimetableDetail(eduTimetableDetailData);
  //       sessionStorage.setItem("eduTimetableDetail", JSON.stringify(eduTimetableDetailData));
  //   } catch(error) {
  //       console.error("Error fetching timetable details for month:", error);
  //       setEduTimetableDetail(null); // 데이터가 없거나 오류 발생 시 상태를 초기화
  //       sessionStorage.removeItem("eduTimetableDetail");
  //   } finally {
  //       setIsTimetableLoading(false);
  //   }

  //   if (customerIdFromStorage !== "") {
  //     try {
  //       const customerDetailResponse = await getEduBoardDetailOnServer(
  //         customerIdFromStorage,
  //         isLoggedIn
  //       );
  //       if (customerDetailResponse) {
  //         setCustomerDetail(customerDetailResponse);
  //         setCompanyName(customerDetailResponse.companyName);
  //       }
  //     } catch (error) {
  //       console.error("고객사 정보를 불러오는 중 오류가 발생했습니다:", error);
  //     }
  //   }
  // };

  // useEffect(() => {
  //   fetchCustomerAndTimetableDetails(monthOffset);
  // }, [monthOffset]);

  // useEffect(() => {
  //   // 주(week) 이동 시 월이 바뀌면, monthOffset을 업데이트하여 해당 월의 데이터를 다시 불러오도록 함
  //   const today = new Date();
  //   const currentDisplayDate = new Date();
  //   currentDisplayDate.setDate(currentDisplayDate.getDate() + currentWeekOffset * 7);

  //   const newMonthOffset = (currentDisplayDate.getFullYear() - today.getFullYear()) * 12 + (currentDisplayDate.getMonth() - today.getMonth());

  //   setMonthOffset(prevMonthOffset => {
  //     if (newMonthOffset !== prevMonthOffset) {
  //       return newMonthOffset;
  //     }
  //     return prevMonthOffset;
  //   });
  // }, [currentWeekOffset]);

  const getLotationList = async () => {
    try {
      const userName = sessionStorage.getItem("userName");
      setCurrentUserName(userName);

      const lotationList = await getEduBoardLotationListOnServer(999, 1);
      const customer = lotationList.data[0];
      setCustomerId(customer._id);
      sessionStorage.setItem("customerId", customer._id);
      setCustomerName(customer.companyName);
      setCustomerDetail(customer);

      // 편성 데이터 로드
      const lotationDetailData = await getEduTimetableLotationDetailOnServer(
        customer._id
      );
      setLotationDetail(lotationDetailData);
    } catch (error) {
      console.error("Error fetching lotation list:", error);
    } finally {
      setIsTimetableLoading(false);
    }
  };

  useEffect(() => {
    const init = async () => {
      try {
        await checkMemberType();
        await getLotationList();
        await fetchContentList();
      } catch (error) {
        console.error("Error initializing:", error);
      } finally {
        setIsTimetableLoading(false);
      }
    };
    init();
  }, []);

  const checkMemberType = async () => {
    const accessToken = sessionStorage.getItem("accessToken");
    const userMemberType = await getUserMemberType(accessToken);

    const lastUrl = sessionStorage.getItem("lastUrl");

    const currentUrl = window.location.href;
    sessionStorage.setItem("lastUrl", currentUrl);

    // fetchCustomerAndTimetableDetails(0); // Initial fetch

    // URL 파라미터 확인하여 콘텐츠 리스트 뷰로 이동
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("view") === "contentsList") {
      setCurrentView("contentsList");
    }

    if (
      (lastUrl === "/ApiDashBoard" || lastUrl === "/CreateApiContent") &&
      userMemberType.member_type === 99
    ) {
      navigate("/Admin");
    }

    if (userMemberType.member_type === 11) {
      navigate("/DashBoard");
    } else if (userMemberType.member_type === 12) {
      navigate("/CustomerManage");
    } else if (userMemberType.member_type === 21) {
      navigate("/ApiDashBoard");
    } else if (userMemberType.member_type === 22) {
      navigate("/CustomerManage");
    }
  };

  // 데이터 fetching 함수 분리
  const fetchContentList = async () => {
    if (!isLoggedIn) {
      return; // 로그인 상태가 아니면 API를 호출하지 않음
    }

    try {
      let response;
      const accessToken = sessionStorage.getItem("accessToken");
      const memberType = await getUserMemberType(accessToken);
      const customerIdFromStorage = sessionStorage.getItem("customerId") || "";

      if (
        customerIdFromStorage === "" &&
        (memberType.member_type === 11 ||
          memberType.member_type === 21 ||
          memberType.member_type === 31)
      ) {
        response = await getDisplayListOnServer(10, 1, isLoggedIn);
        setDisplayList(response.data);
      } else {
        response = await getDisplayListCustomerOnServer(
          customerIdFromStorage,
          999,
          1,
          isLoggedIn
        );
        setDisplayList(response.data);
      }

      let viewList;

      if (
        customerIdFromStorage === "" &&
        (memberType.member_type === 11 ||
          memberType.member_type === 21 ||
          memberType.member_type === 31)
      ) {
        viewList = await getEduViewListOnServer(10, 1, isLoggedIn);
        setContentList(viewList.data);
        setActivateCount(viewList.activate_count);
      } else {
        viewList = await getEduViewListCustomerOnServer(
          customerIdFromStorage,
          999,
          1,
          isLoggedIn
        );

        setContentList(viewList.data);
        setActivateCount(viewList.activate_count);
      }

      setContentList(viewList.data);

      setContentListAllCount(
        viewList.data.filter(
          (content) => {
            const targets = Array.isArray(content.contentsTarget)
              ? content.contentsTarget
              : [content.contentsTarget || "전교생"];
            return targets.includes("전교생") ||
                   content.designConcept === "happy" ||
                   content.designConcept === "healthy";
          }
        ).length
      );
      setContentListGrade1Count(
        viewList.data.filter(
          (content) => {
            const targets = Array.isArray(content.contentsTarget)
              ? content.contentsTarget
              : [content.contentsTarget || ""];
            return targets.includes("1학년 학생");
          }
        ).length
      );
      setContentListGrade2Count(
        viewList.data.filter(
          (content) => {
            const targets = Array.isArray(content.contentsTarget)
              ? content.contentsTarget
              : [content.contentsTarget || ""];
            return targets.includes("2학년 학생");
          }
        ).length
      );
      setContentListGrade3Count(
        viewList.data.filter(
          (content) => {
            const targets = Array.isArray(content.contentsTarget)
              ? content.contentsTarget
              : [content.contentsTarget || ""];
            return targets.includes("3학년 학생");
          }
        ).length
      );
    } catch (error) {
      console.error("콘텐츠 리스트를 불러오는 중 오류가 발생했습니다:", error);
    }
  };

  // const fetchCompanyName = async () => {
  //   const accessToken = sessionStorage.getItem("accessToken");
  //   // const memberType = await getUserMemberType(accessToken);
  //   if (customerId === "") {
  //     const userInfo = await getUserInfo(accessToken);
  //     setCustomerName(userInfo.organization_name);
  //   }
  // };

  // useEffect(() => {
  //   fetchContentList();
  //   fetchCompanyName();
  // }, [isLoggedIn]);

  const handleCustomizePopupClose = () => {
    setIsCustomizePopupOpen(false);
    setActiveTabIndex(0);
    setAddDisplayForm({
      deviceTitle: "",
      deviceLocation: "",
      deviceTarget: "",
      deviceSpec: {
        deviceWidth: "",
        deviceHeight: "",
        deviceCm: "",
        deviceResolution: "",
        deviceDPI: "",
        deviceInch: "",
      },
    });
  };

  const handleCustomizePopupConfirm = () => {
    if (activeTabIndex < 2) {
      setActiveTabIndex(activeTabIndex + 1);
    } else {
      handleCustomizePopupClose();
    }
  };

  const toggleSelectBox = (type) => {
    setSelectBoxStates((prev) => ({
      ...prev,
      [type]: !prev[type],
    }));
  };

  const handleFormChange = useCallback((field, value) => {
    setAddDisplayForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  }, []);

  const isFormValid = () => {
    const deviceDPIValid =
      addDisplayForm.deviceDPI &&
      (addDisplayForm.deviceDPI !== "기타" || addDisplayForm.deviceInch);

    return (
      addDisplayForm.deviceTitle &&
      addDisplayForm.deviceLocation &&
      addDisplayForm.deviceTarget &&
      deviceDPIValid &&
      addDisplayForm.deviceInch &&
      addDisplayForm.deviceSpec.deviceWidth &&
      addDisplayForm.deviceSpec.deviceHeight
    );
  };

  // 새 콘텐츠 버튼 클릭 시 뷰 전환
  const handleNewContentClick = () => {
    setCurrentView("contentsList");
  };

  // 뒤로가기 핸들러
  const handleBackToDashboard = async () => {
    const customerId = sessionStorage.getItem("customerId");
    const lotationDetailData = await getEduTimetableLotationDetailOnServer(
      customerId
    );
    setLotationDetail(lotationDetailData);

    setCurrentView("dashboard");
    // URL 파라미터 제거
    const url = new URL(window.location);
    url.searchParams.delete("view");
    window.history.replaceState({}, "", url);
  };

  // AutodisplaySelectedPopup에서 기기 선택 시
  const handleAutoDisplaySelect = () => {
    //! 추후 수정
    const originalDevice = {
      _id: "6879e4719eec30c7d8116b30",
      createDate: "2025. 07. 18. 오후 03:06:41",
      user: "gyeongwon_admin@userconnect.kr",
      customer: "6877467b7d2ec89430c251b2",
      deviceSpec: {
        deviceWidth: "3840",
        deviceHeight: "2160",
        deviceWidthMM: "1896",
        deviceHeightMM: "1063",
        deviceCm: "218.44",
        deviceResolution: "UHD",
        deviceDPI: "(가로) UHD | 3840 × 2160",
        deviceInch: "86인치",
      },
      deviceTitle: "디지털 칠판",
      timestamp: 1752818801284,
      updateDate: "2025. 07. 18. 오후 03:06:41",
    };

    if (originalDevice) {
      setSelectedDevice(originalDevice);
      setShowDeviceSelectPopup(false);

      // customerDetail이 null인 경우를 안전하게 처리
      const boardType = customerDetail?.boardType || "general";

      if (boardType === "general") {
        navigate("/CreateEducationContent", {
          state: { selectedDevice: originalDevice },
        });
      } else if (boardType === "meal") {
        navigate("/CreateEducationMeal", {
          state: { selectedDevice: originalDevice },
        });
      } else {
        navigate("/CreateEducationContent", {
          state: { selectedDevice: originalDevice },
        });
      }
    }
  };

  // const handleAutoDisplayClose = () => {
  //   setShowDeviceSelectPopup(false);
  // };

  // const handleSaveNewDisplay = async (displayData) => {
  //   try {
  //     // customerId가 있으면 displayData에 추가
  //     if (customerId !== "") {
  //       displayData.customer = customerId;
  //     }
  //     // 1. 먼저 새 디스플레이 ID를 생성
  //     const newDisplayId = await createDisplayOnServer(isLoggedIn);

  //     if (!newDisplayId) {
  //       throw new Error("디스플레이 ID 생성에 실패했습니다.");
  //     }

  //     // 2. 생성된 ID에 디스플레이 정보를 업데이트
  //     await updateDisplayOnServer(newDisplayId, displayData);

  //     // 3. 디스플레이 목록 새로고침
  //     await fetchContentList();
  //   } catch (error) {
  //     console.error("새 디스플레이 저장 실패:", error);
  //     throw error; // AutodisplaySelectedPopup에서 에러 처리하도록 전달
  //   }
  // };

  // const handleDomainKeyGenerate = async () => {
  //   try {
  //     const createDisplayId = await createDisplayOnServer(isLoggedIn);
  //     // 성공 시 후속 처리, 예를 들어 팝업을 닫거나 상태 업데이트
  //     const response = await updateDisplayOnServer(
  //       createDisplayId,
  //       addDisplayForm
  //     );

  //     // 도메인 키 생성 성공 후 데이터 다시 불러오기
  //     await fetchContentList();
  //   } catch (error) {
  //     console.error("도메인 키 생성 오류:", error);
  //     // 실패 시 에러 처리
  //   } finally {
  //     setIsCustomizePopupOpen(false);
  //     handleCustomizePopupClose();
  //   }
  // };

  // 사이즈 계산 로직
  useEffect(() => {
    const { deviceDPI, deviceInch } = addDisplayForm.deviceSpec;

    if (!deviceDPI || !deviceInch) return;

    try {
      const resolutionMatch = deviceDPI.match(/(\d{3,})\s*[×x*]\s*(\d{3,})/);
      const inchMatch = deviceInch.match(/(\d+(\.\d+)?)/);

      if (!resolutionMatch || !inchMatch) return;

      const widthPx = parseInt(resolutionMatch[1], 10);
      const heightPx = parseInt(resolutionMatch[2], 10);
      const diagonalInch = parseFloat(inchMatch[1]);

      const aspectRatio = widthPx / heightPx;
      const heightInch = diagonalInch / Math.sqrt(aspectRatio ** 2 + 1);
      const widthInch = heightInch * aspectRatio;

      const widthMm = Math.round(widthInch * 25.4);
      const heightMm = Math.round(heightInch * 25.4);

      setAddDisplayForm((prev) => ({
        ...prev,
        deviceSpec: {
          ...prev.deviceSpec,
          deviceWidth: widthPx.toString(),
          deviceHeight: heightPx.toString(),
          deviceWidthMM: widthMm.toString(),
          deviceHeightMM: heightMm.toString(),
        },
      }));
    } catch (e) {
      console.error("Failed to calculate display size", e);
    }
  }, [
    addDisplayForm.deviceSpec.deviceDPI,
    addDisplayForm.deviceSpec.deviceInch,
  ]);

  const handleCreateContentPopup = () => {
    setShowDeviceSelectPopup(true);
  };

  const handleEditDisplayPopup = (displayId) => {
    setShowDeviceSelectPopup(true);
    setSelectedEditDisplayId(displayId);
  };

  // 콘텐츠 생성 핸들러 (TemplateEducationContentsList에서 사용)
  const handleCreateNewContent = async () => {
    // customerDetail이 없는 경우 다시 로드 시도
    if (!customerDetail) {
      // await fetchCustomerAndTimetableDetails(monthOffset);
    }
    handleAutoDisplaySelect(); // 기존 로직 재사용
  };

  // 일반 콘텐츠 생성 핸들러
  const handleCreateGeneralContent = () => {
    const originalDevice = {
      _id: "6879e4719eec30c7d8116b30",
      createDate: "2025. 07. 18. 오후 03:06:41",
      user: "gyeongwon_admin@userconnect.kr",
      customer: "6877467b7d2ec89430c251b2",
      deviceSpec: {
        deviceWidth: "3840",
        deviceHeight: "2160",
        deviceWidthMM: "1896",
        deviceHeightMM: "1063",
        deviceCm: "218.44",
        deviceResolution: "UHD",
        deviceDPI: "(가로) UHD | 3840 × 2160",
        deviceInch: "86인치",
      },
      deviceTitle: "디지털 칠판",
      timestamp: 1752818801284,
      updateDate: "2025. 07. 18. 오후 03:06:41",
    };

    setSelectedDevice(originalDevice);
    navigate("/CreateEducationContent", {
      state: { selectedDevice: originalDevice },
    });
  };

  // 급식 콘텐츠 생성 핸들러
  const handleCreateMealContent = () => {
    const originalDevice = {
      _id: "6879e4719eec30c7d8116b30",
      createDate: "2025. 07. 18. 오후 03:06:41",
      user: "gyeongwon_admin@userconnect.kr",
      customer: "6877467b7d2ec89430c251b2",
      deviceSpec: {
        deviceWidth: "3840",
        deviceHeight: "2160",
        deviceWidthMM: "1896",
        deviceHeightMM: "1063",
        deviceCm: "218.44",
        deviceResolution: "UHD",
        deviceDPI: "(가로) UHD | 3840 × 2160",
        deviceInch: "86인치",
      },
      deviceTitle: "디지털 칠판",
      timestamp: 1752818801284,
      updateDate: "2025. 07. 18. 오후 03:06:41",
    };

    setSelectedDevice(originalDevice);
    navigate("/CreateEducationMeal", {
      state: { selectedDevice: originalDevice },
    });
  };

  // 링크 콘텐츠 생성 핸들러
 const handleCreateLinkContent = () => {
    const originalDevice = {
      _id: "6879e4719eec30c7d8116b30",
      createDate: "2025. 07. 18. 오후 03:06:41",
      user: "gyeongwon_admin@userconnect.kr",
      customer: "6877467b7d2ec89430c251b2",
      deviceSpec: {
        deviceWidth: "3840",
        deviceHeight: "2160",
        deviceWidthMM: "1896",
        deviceHeightMM: "1063",
        deviceCm: "218.44",
        deviceResolution: "UHD",
        deviceDPI: "(가로) UHD | 3840 × 2160",
        deviceInch: "86인치",
      },
      deviceTitle: "디지털 칠판",
      timestamp: 1752818801284,
      updateDate: "2025. 07. 18. 오후 03:06:41",
    };

    setSelectedDevice(originalDevice);
    navigate("/CreateEducationLink", {
      state: { selectedDevice: originalDevice },
    });
  };

  // 학습 콘텐츠 생성 핸들러
  const handleCreateLearningContent = () => {
    const originalDevice = {
      _id: "6879e4719eec30c7d8116b30",
      createDate: "2025. 07. 18. 오후 03:06:41",
      user: "gyeongwon_admin@userconnect.kr",
      customer: "6877467b7d2ec89430c251b2",
      deviceSpec: {
        deviceWidth: "3840",
        deviceHeight: "2160",
        deviceWidthMM: "1896",
        deviceHeightMM: "1063",
        deviceCm: "218.44",
        deviceResolution: "UHD",
        deviceDPI: "(가로) UHD | 3840 × 2160",
        deviceInch: "86인치",
      },
      deviceTitle: "디지털 칠판",
      timestamp: 1752818801284,
      updateDate: "2025. 07. 18. 오후 03:06:41",
    };

    setSelectedDevice(originalDevice);
    navigate("/CreateEducationLearning", {
      state: { selectedDevice: originalDevice },
    });
  };

  // 뷰 전환 조건부 렌더링
  if (currentView === "contentsList") {
    return (
      <TemplateEducationContentsList
        onBack={handleBackToDashboard}
        onCreateContent={handleCreateNewContent}
        onCreateGeneralContent={handleCreateGeneralContent}
        onCreateMealContent={handleCreateMealContent}
        onCreateLinkContent={handleCreateLinkContent}
        onCreateLearningContent={handleCreateLearningContent}
      />
    );
  }

  return (
    <DashboardContainer>
      <MoleculeHeader />

      {/* 메인 컨텐츠 */}
      <MainContent>
        {/* 상단 섹션 */}
        {/* <TopSection> */}
        {/* <CompanyInfo>
            <Avatar />
            <CompanyName>{companyName}</CompanyName>
          </CompanyInfo> */}
        <ButtonGroup>
          {/* <Button dbExLarge Fill PrimaryLightest onClick={showPopup}>
              <Sub2 color="primary">새 기기 등록</Sub2>
            </Button> */}
          {/* <Button Large Primary Fill onClick={() => handleNewContentClick()}>
              <Sub2 color="white">콘텐츠 생성하기</Sub2>
            </Button> */}
        </ButtonGroup>
        {/* </TopSection> */}

        {/* 통계 섹션 */}
        <StatsSection>
          <TopSection>
            {/* <SectionTitle>{currentUserName} 선생님</SectionTitle> */}
            <SectionTitle> {customerName} 콘텐츠 통합 관리</SectionTitle>
            {/* <SectionTitle> 유저커넥트 콘텐츠 통합 관리</SectionTitle> */}
            <ButtonGroup>
              <Button
                Large
                Primary
                Fill
                onClick={() => handleNewContentClick()}
                style={{ display: "inline-flex", alignItems: "center" }}
              >
                <svg
                  width={20}
                  height={20}
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ flexShrink: 0 }}
                >
                  <path
                    d="M9.99935 4.16669V15.8334M4.16602 10H15.8327"
                    stroke="white"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <Sub2 color="white">콘텐츠 생성하기</Sub2>
              </Button>
            </ButtonGroup>
          </TopSection>
          <StatsGrid>
            <StatCard>
              <StatTitle>
                <H4 color="gray800">콘텐츠 현황 </H4>
                <Body2 color="gray700">
                  활성화 콘텐츠 수 / 전체 콘텐츠 수{" "}
                </Body2>
              </StatTitle>
              <StartContent>
                <StatGroup>
                  <StatValue>
                    {isTimetableLoading ||
                    !lotationDetail ||
                    !contentListAllCount ? (
                      "- / -"
                    ) : (
                      <>
                        <ActivatedCount>
                          {lotationDetail?.gradeAll?.length || 0}
                        </ActivatedCount>
                        {` / ${contentListAllCount}`}
                      </>
                    )}
                  </StatValue>
                  <StatHeader>
                    <Body2 color="gray600"> 전학년 콘텐츠 수 </Body2>
                    {/* <Body2 color="gray600">개수</Body2> */}
                  </StatHeader>
                </StatGroup>
                <StatGroup>
                  <StatValue>
                    {isTimetableLoading ||
                    !lotationDetail ||
                    !contentListGrade1Count ? (
                      "- / -"
                    ) : (
                      <>
                        <ActivatedCount>
                          {lotationDetail?.grade1?.length || 0}
                        </ActivatedCount>
                        {` / ${contentListGrade1Count}`}
                      </>
                    )}
                  </StatValue>
                  <StatHeader>
                    <Body2 color="gray600"> 1학년 콘텐츠 수 </Body2>
                    {/* <Body2 color="gray600">개수</Body2> */}
                  </StatHeader>
                </StatGroup>
                <StatGroup>
                  <StatValue>
                    {isTimetableLoading ||
                    !lotationDetail ||
                    !contentListGrade2Count ? (
                      "- / -"
                    ) : (
                      <>
                        <ActivatedCount>
                          {lotationDetail?.grade2?.length || 0}
                        </ActivatedCount>
                        {` / ${contentListGrade2Count}`}
                      </>
                    )}
                  </StatValue>
                  <StatHeader>
                    <Body2 color="gray600"> 2학년 콘텐츠 수 </Body2>
                    {/* <Body2 color="gray600">개수</Body2> */}
                  </StatHeader>
                </StatGroup>
                <StatGroup>
                  <StatValue>
                    {isTimetableLoading ||
                    !lotationDetail ||
                    !contentListGrade3Count ? (
                      "- / -"
                    ) : (
                      <>
                        <ActivatedCount>
                          {lotationDetail?.grade3?.length || 0}
                        </ActivatedCount>
                        {` / ${contentListGrade3Count}`}
                      </>
                    )}
                  </StatValue>
                  <StatHeader>
                    <Body2 color="gray600"> 3학년 콘텐츠 수 </Body2>
                    {/* <Body2 color="gray600">개수</Body2> */}
                  </StatHeader>
                </StatGroup>
              </StartContent>
            </StatCard>
          </StatsGrid>
        </StatsSection>

        <TimelineSection>
          <StatHeader2>
            {/* <H4 color="primary">
              {companyName.includes("학년 주임")
                ? companyName[0] + "학년"
                : companyName}{" "}
            </H4> */}
            <H4 color="primary">{customerName} </H4>
            <H4 color="gray700">콘텐츠 편성 관리 </H4>
          </StatHeader2>
          {isTimetableLoading ? (
            <LoadingSpinner>
              <Spinner />
            </LoadingSpinner>
          ) : (
            <>
              <OrganismContentList
                contentList={contentList}
                lotationDetail={lotationDetail}
                onLotationUpdate={async () => {
                  // 편성 데이터가 업데이트되면 다시 로드
                  try {
                    const updatedLotationDetail =
                      await getEduTimetableLotationDetailOnServer(customerId);
                    setLotationDetail(updatedLotationDetail);
                    console.log(
                      "Lotation Detail refreshed:",
                      updatedLotationDetail
                    );
                  } catch (error) {
                    console.error("Error refreshing lotation detail:", error);
                  }
                }}
              />
              {/* {timelineViewType === 'weekly' ? (
                <MoleculeContentTimeline 
                  viewType={timelineViewType}
                  onViewTypeChange={setTimelineViewType}
                  weekOffset={currentWeekOffset}
                  onWeekOffsetChange={setCurrentWeekOffset}
                  contentList={contentList}
                  eduTimetableDetail={eduTimetableDetail}
                />
              ) : (
                <MoleculeContentTimeMonth 
                  viewType={timelineViewType}
                  onViewTypeChange={setTimelineViewType}
                  contentList={contentList}
                  eduTimetableDetail={eduTimetableDetail}
                  monthOffset={monthOffset}
                  onMonthOffsetChange={setMonthOffset}
                  onDateSelect={(date) => {
                    // 선택된 날짜가 속한 주로 정확히 이동
                    const selectedDate = new Date(date);
                    const today = new Date();
                    
                    // 실제 오늘 날짜의 월요일 계산 (weekOffset 적용 전)
                    const realTodayMonday = new Date(today);
                    const realTodayDay = realTodayMonday.getDay();
                    const realTodayDiff = realTodayMonday.getDate() - realTodayDay + (realTodayDay === 0 ? -6 : 1);
                    realTodayMonday.setDate(realTodayDiff);
                    realTodayMonday.setHours(0, 0, 0, 0);
                    
                    // 선택된 날짜가 속한 주의 월요일 계산
                    const selectedMonday = new Date(selectedDate);
                    const selectedDay = selectedMonday.getDay();
                    const selectedDiff = selectedMonday.getDate() - selectedDay + (selectedDay === 0 ? -6 : 1);
                    selectedMonday.setDate(selectedDiff);
                    selectedMonday.setHours(0, 0, 0, 0);
                    
                    // 실제 오늘 날짜 기준으로 선택된 날짜까지의 주 단위 차이 계산
                    const diffTime = selectedMonday.getTime() - realTodayMonday.getTime();
                    const diffWeeks = Math.round(diffTime / (7 * 24 * 60 * 60 * 1000));
                    
                    setCurrentWeekOffset(diffWeeks);
                    setTimelineViewType('weekly');
                  }}
                />
              )} */}
            </>
          )}
        </TimelineSection>
        {/* 탭 및 테이블 섹션 */}

        {/* <TableSection>
          <TabContainer>
            <TabWrapType3>
              <SectionTitle>등록 콘텐츠 리스트</SectionTitle>
            </TabWrapType3>

            <CustomPopupSubtitle>
              콘텐츠 연결 주소:{" "}
              <ContentLink
                href={`${window.location.origin}/autodisplayViewEdu`}
                target="_blank"
                rel="noopener noreferrer"
              >
                autodisplayViewEdu
              </ContentLink>
            </CustomPopupSubtitle>
          </TabContainer>

          {activeTab === "content" ? (
            <OrganismEduDashboardContentList
              handleCreateContent={handleAutoDisplaySelect}
            />
          ) : (
            <OrganismDashboardDisplayList
              handleEditDisplayPopup={handleEditDisplayPopup}
            />
          )}
        </TableSection> */}
      </MainContent>

      {/* 기기 없음 알림 팝업 */}

      {/* 기기 선택 팝업 */}
      {/* {showDeviceSelectPopup && (
        <AutodisplaySelectedPopup
          onClose={handleAutoDisplayClose}
          onSelect={handleAutoDisplaySelect}
          onSaveNewDisplay={handleSaveNewDisplay}
          selectedEditDisplayId={selectedEditDisplayId}
        />
      )} */}

      {/* {showConfirmPopup && (
        <PopupWrap
          Warning
          title="정말 활성화 하시겠습니까?"
          // message={
          //   <>
          //     보유한 크레딧이 부족합니다.
          //     <br />
          //     크레딧을 충전한 후 다시 시도해주세요.
          //   </>
          // }
          buttonType="Outline"
          closeText="취소"
          confirmText="확인"
          isModal={false}
          onCancel={() => {
            setShowConfirmPopup(false);
          }}
          onConfirm={() => {
            setShowConfirmPopup(false);
            handleDomainKeyGenerate();
          }}
        />
      )} */}
    </DashboardContainer>
  );
};

export default PageEducationDashBoard;

// PopupContent 스타일 추가
const PopupContent = styled.div`
  margin-top: 8px;
`;

// 스타일 컴포넌트들
const DashboardContainer = styled.div`
  width: 100%;
  max-width: 2330px;
  margin: 0 auto;
  background: ${palette.white};
  min-height: 100vh;
`;

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 40px;
  height: 56px;
`;

const Logo = styled.h1`
  font-family: Poppins;
  font-weight: 700;
  font-size: 20px;
  color: #323232;
  margin: 0;
`;

const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

const CreditSection = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const CreditIcon = styled.div`
  width: 20px;
  height: 20px;
  background: #ffd54a;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
`;

const CreditText = styled.span`
  font-family: Pretendard;
  font-weight: 500;
  font-size: 14px;
  color: #323232;
`;

const CreditArrow = styled.span`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #cccccc;
`;

const NotificationIcon = styled.div`
  width: 18px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MoreIcon = styled.div`
  width: 18px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #e0e4eb;
`;

const MainContent = styled.main`
  max-width: 1240px;
  margin: 0 auto;
  padding: 72px 0;
  display: flex;
  flex-direction: column;
  gap: 72px;
`;

const TopSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
`;

const CompanyInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Avatar = styled.div`
  width: 48px;
  height: 48px;
  background: #d9d9d9;
  border-radius: 50%;
  background-image: url("/logo192.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

const CompanyName = styled.h2`
  font-family: poppins;
  font-weight: 700;
  font-size: 40px;
  color: #1e2124;
  margin: 0;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 20px;
`;

const StatsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const SectionTitle = styled.h3`
  font-family: Pretendard;
  font-weight: 600;

  font-size: 32px;
  color: #323232;
  margin: 0;
  text-align: left;
`;

const StatsGrid = styled.div`
  display: flex;
  gap: 20px;
`;

const StatCard = styled.div`
  flex: 1;
  background: ${palette.white};
  border: 1px solid #e0e4eb;
  border-radius: 10px;
  padding: 24px 32px 32px 32px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  text-align: left;
`;

const StatTitle = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e0e4eb;
  text-align: left;
  align-items: flex-end;
`;

const StartContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  gap: 150px;
`;

const StatGroup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const StatHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StatHeader2 = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
`;

const StatValue = styled.div`
  font-family: Poppins;
  font-weight: 700;
  font-size: 30px;
  color: #666666;
  text-align: left;
`;

const TimelineSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const TableSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const TabContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
`;

const TabGroup = styled.div`
  display: flex;
  gap: 8px;
`;

const Tab = styled.button`
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid ${({ active }) => (active ? "#E0E4EB" : "#e0e4eb")};
  background: ${({ active }) => (active ? "#F7F8FA" : "transparent")};
  color: ${palette.gray700};
  font-weight: ${({ active }) => (active ? 600 : 400)};
  font-size: 15px;
  cursor: pointer;
  margin-right: 8px;
  transition: background 0.2s, color 0.2s, border 0.2s;

  &:last-child {
    margin-right: 0;
  }
`;

const Table = styled.div`
  border-radius: 0;
  overflow: hidden;
`;

const TableHeader = styled.div`
  display: flex;
  background: #eef2f7;
`;

const TableBody = styled.div`
  display: flex;
  flex-direction: column;
`;

const TableRow = styled.div`
  display: flex;
  background: ${palette.white};

  &:not(:last-child) {
    border-bottom: 1px solid #cdd1d5;
  }
`;

const HeaderCell = styled.div`
  padding: 20px 16px;
  font-family: Pretendard;
  font-weight: 700;
  font-size: 15px;
  color: #131416;
  border-right: 1px solid #d6e0eb;

  ${(props) =>
    props.wide
      ? `
    flex: 1;
    text-align: left;
  `
      : `
    width: 240px;
    text-align: right;
  `}

  &:last-child {
    border-right: none;
  }
`;

const TableCell = styled.div`
  padding: 20px 16px;
  font-family: Pretendard;
  font-weight: 400;
  font-size: 17px;
  color: #464c53;
  border-right: 1px solid #cdd1d5;

  ${(props) =>
    props.wide
      ? `
    flex: 1;
    text-align: left;
  `
      : `
    width: 240px;
    text-align: right;
  `}

  &:last-child {
    border-right: none;
  }
`;

const PopupFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 0;
`;

const FormField = styled.div`
  display: flex;
  flex-direction: column;
  // gap: 4px;
  flex: ${(props) => props.flex || "none"};
  margin-bottom: -10px;

  Body2 {
    margin-bottom: 10px;
  }
`;

const FormRow = styled.div`
  display: flex;
  gap: 16px;
`;

const SizeInputRow = styled.div`
  display: flex;
  gap: 16px;
`;

const SizeInputGroup = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const SizeInput = styled.input`
  flex: 1;
  padding: 16px;
  border: 1px solid #e0e4eb;
  border-radius: 10px;
  font-size: 1rem;
  color: ${palette.gray700};

  &:focus {
    outline: none;
    border-color: ${palette.primary};
  }

  &::placeholder {
    color: ${palette.gray500};
  }
`;

const SizeUnit = styled.span`
  font-size: 14px;
  color: ${palette.gray600};
  min-width: 24px;
`;

const ButtonCenter = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const InfoBox = styled.div`
  background-color: ${palette.primaryLightest};
  border-radius: 8px;
  padding: 16px;
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  // gap: 16px;
`;

const LargeButton = styled(Button)`
  width: 200px;
  padding: 16px 32px;
  font-size: 16px;
  min-height: 56px;
`;

const DirectInputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
`;

const ResetButton = styled.button`
  background: none;
  border: none;
  color: ${palette.gray400};
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;

  &:hover {
    background-color: ${palette.gray100};
    color: ${palette.gray700};
  }
`;

const ContentLink = styled.a`
  color: ${palette.primary};
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: ${palette.primary}DD;
    text-decoration: underline;
  }

  &:visited {
    color: ${palette.primary};
  }
`;

const CustomPopupSubtitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${palette.gray600};
  margin: 0;
  margin-bottom: 12px;
`;

const StatCardContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const DisplayInfoContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

const DisplayInfoText = styled.div`
  font-family: Pretendard;
  font-weight: 500;
  font-size: 24px;
  color: #666666;
  font-weight: 700;
  text-align: left;
  line-height: 1.8;
`;

const LoadingSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 500px; // 타임라인의 대략적인 높이
`;

const Spinner = styled.div`
  border: 4px solid rgba(0, 0, 0, 0.1);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border-left-color: #09f;
  animation: spin 1s ease infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

const ActivatedCount = styled.span`
  color: ${palette.primary};
`;
